"use client";

import { useMemo } from "react";
import { useI18n } from "@/components/providers/i18n-provider";
import { getTranslation, getTranslations } from "@/lib/i18n/translations";
import type { Locale } from "@/i18n/config";

/**
 * Hook to get user's preferred language
 */
export function useLocale(): Locale {
  const { locale } = useI18n();
  return locale;
}

/**
 * Hook to use translations
 * This hook will re-render when the locale changes or translations are loaded
 */
export function useTranslations(namespace?: string) {
  const { locale, translationVersion } = useI18n(); // Get locale and version from context to ensure reactivity

  const t = useMemo(() => {
    if (namespace) {
      const translations = getTranslations(locale, namespace);
      return (key: string, params?: Record<string, string | number>) => {
        const fullKey = `${namespace}.${key}`;
        return getTranslation(locale, fullKey, params);
      };
    }
    
    return (key: string, params?: Record<string, string | number>) => {
      return getTranslation(locale, key, params);
    };
  }, [locale, namespace, translationVersion]); // Include translationVersion to force re-render when translations load

  return { t, locale };
}

